<template>
  <li class=" onhover-dropdown p-0 mr-0">
    <div class="media profile-media">
      <img
          v-if="user"
          class="b-r-10" style="width: 37px"
          :src="user.image"
          alt=""
      />
      <div class="media-body" v-if="user">
        <span>{{ user.name }}</span>
        <p class="mb-0 font-roboto">
          {{ user.email }} <i class="middle fa fa-angle-down"></i>
        </p>
      </div>
    </div>


    <ul class="profile-dropdown onhover-show-div">
      <li>
        <router-link :to="{name: 'ProjectsList'}">
          <feather type="archive"></feather>
          <span>{{ $t("message.header_plan") }}</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{name: 'UserProfile'}">
          <feather type="user"></feather>
          <span>{{ $t("message.header_account") }}</span>
        </router-link>
      </li>
      <li v-for="page in menuPages">
        <router-link :to="{ name: 'SinglePage', params: {slug: page.slug}}" target="_blank">
          <feather type="external-link"></feather>
          <span>{{ page.title }}</span>
        </router-link>
      </li>
      <li>
        <a @click.stop.prevent="logout"
        >
          <feather type="log-in"></feather>
          <span>{{ $t("message.header_log_out") }}</span></a
        >
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  name: 'Profile',
  props: {
    menuPages: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    logout: async function () {
      await this.$store.dispatch('shared/logout')
      this.$router.push({name: 'Login'}).catch(() => {
      })
    }
  },
  computed: {
    user() {
      return this.$store.getters['shared/getUser']
    }
  }
};
</script>
